const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category input component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('categoryInput', ['Application', 'Categories', '$translate', function (Application, Categories, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      category: '=',
      type: '=?',
      language: '=',
      featured: '@',
      level: '@',
      addCategory: '&',
      removeCategory: '&',
      itemClick: '&',
      refresh: '&?'
    },
    template: require('../../templates/directives/category-input.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translatedValues = {};
      self.translations = {};
      self.languages;
      var originalName;

      self.parseCategory = function() {
        var list = $scope.category.localized_names || '';
        list = list.split(',');
        for (var i = 0; i < list.length; i++) {
          var items = list[i].split(':');
          if (items.length !== 2) {
            continue;
          }
          self.translatedValues[items[0].toLowerCase()] = items[1];
        }
      };
      self.itemClick = function() {
        $scope.itemClick({category: $scope.category});
      };
      self.addCategory = function() {
        $scope.addCategory({category: $scope.category});
      };

      self.removeCategory = function() {
        $scope.removeCategory({category: $scope.category});
      };

      self.cancel = function() {
        $scope.category.name = originalName;
        self.edit = false;
        self.contextMenu = false;
      };

      self.toggleExternal = function(override) {

        if ($scope.category.show_external) {
          if (!override && $scope.category.children && $scope.category.children.length) {
            self.lineageToggle();
            return;
          }
          $scope.category.show_external = false;
          self.save();
          return;
        }

        $scope.category.show_external = true;
        self.save();
      };

      self.lineageToggle = function() {
        self.saving = true;
        Categories.toggleExternal({subsubresource:$scope.category._id}, {apply_to_children: true}).$promise
        .then(function(results) {
          Application.messaging.addMessage({type: 'success', text: self.translations['categoryInput.all_hidden_from_external'], duration: 8});
          if ($scope.refresh) {
            $scope.refresh();
          }

          self.saving = false;
          self.showExternalModal = false;
        }).catch(function(error) {
          console.log('error: ', error)
        })
      }

      self.save = function() {
        self.saving = true;
        var tString = '';
        if (Object.keys(self.translatedValues).length) {
          // stringify the localized names
          for (var key in self.translatedValues) {
            if (self.translatedValues[key]) {
              tString += key + ':' + self.translatedValues[key] + ',';
            }
          }
          $scope.category.localized_names = tString;
        }

        var body = {};
        if (tString) {
          body.localized_names = tString;
        }
        if (!$scope.category.name) {
          for (var key in self.translatedValues) {
            if (self.translatedValues[key]) {
              $scope.category.name = self.translatedValues[key];
              break;
            }
          }
        }
        if (!$scope.category.name) {

          var type = '';
          if ($scope.category.category === true){
            type = 'category';
          }
          else if ($scope.category.location === true){
            type = 'location';
          }
          else if ($scope.category.department === true){
            type = 'department';
          }
          else if ($scope.category.team === true){
            type = 'team';
          }
          else if ($scope.category.org_level === true){
            type = 'org_level';
          }
          else if ($scope.category.grade === true){
            type = 'grade';
          };

          $translate('manage.categories.message_namingError', { type: type }).then(function(data){
            Application.messaging.addMessage({type: 'error', text: data, duration: 5});
          });
          return;
        }

        body.name = $scope.category.name;
        body.show_external = $scope.category.show_external;
        if ($scope.featured && !$scope.category._id) {
          body.level = 10;
          body.parent = null;
          body.category = true;
          body.location = false;
          body.department = false;
          body.team = false;
          body.org_level = false;
          body.grade = false;
          body.children = [];
        }

        Categories.update({subresource: $scope.category._id}, body).$promise
        .then(function(data) {
          $scope.category.name = data.name;
          // confirm success
          var type = '';
          if ($scope.category.category === true){
            type = 'category';
          }
          else if ($scope.category.location === true){
            type = 'location';
          }
          else if ($scope.category.department === true){
            type = 'department';
          }
          else if ($scope.category.team === true){
            type = 'team';
          }
          else if ($scope.category.org_level === true){
            type = 'org_level';
          }
          else if ($scope.category.grade === true){
            type = 'grade';
          };

          $translate('manage.categories.message_successUpdate', { type: type }).then(function(data){
            Application.messaging.addMessage({type: 'success', text: data, duration: 5});
          });

          self.edit = false;
          self.saving = false;
          self.showExternalModal = false;
        });
      };

      self.initialize = function() {
        originalName = $scope.category.name.slice(0);
        self.languages = Application.languages.getAvailable();

        for (var i = 0; i < self.languages.length; i++) {
          if (self.languages[i].abr === 'en') {
            continue;
          }

          self.translatedValues[self.languages[i].abr.toLowerCase()] = '';
        }
        self.parseCategory();
      };

      var retry = 0;
      var retryInit = function() {
        setTimeout(function() {
          if ($scope.category && $scope.category.name) {
            self.initialize();
            return;
          }
          if (retry <= 2) {
            retry++;
            retryInit();
          }
        }, 500);
      };

      if (!$scope.category || !$scope.category.name) {
        retryInit();
      } else {
        self.initialize();
      }

    }],
    controllerAs: 'categoryInput',
    link: function(scope, element, attrs) {
      var el = element[0];
      var menu1 = el.querySelector('#menutrigger1');
      var menu2 = el.querySelector('#menutrigger2');
      var menuClicked = false;
      var containerClicked = false;
      var checkClose = function() {
        if (!menuClicked && scope.categoryInput.edit || !menuClicked && scope.categoryInput.contextMenu) {
          scope.categoryInput.cancel();
          scope.$apply();
        } else if (!menuClicked && containerClicked) {
          scope.categoryInput.itemClick();
          scope.$apply();
        }
        menuClicked = false;
        containerClicked = false;
      };

      document.addEventListener("click", function (item) {
        checkClose();
      });
      el.addEventListener("click", function (item) {
        containerClicked = true;
      });
      menu1.addEventListener("click", function (item) {
        menuClicked = true;
      });
      menu2.addEventListener("click", function (item) {
        menuClicked = true;
      });

      $translate(['categoryInput.all_hidden_from_external']).then(function (translations) {
        self.translations = translations;
      });

    }
  };
}]);
